// Color Pallete
//

// Blue
export const B50 = '#F6FAFF';
export const B100 = '#E3EEFF';
export const B200 = '#C4DAFD';
export const B300 = '#71A7FF';
export const B400 = '#3A83F9';
export const B500 = '#0760ED';
export const B600 = '#0648B2';
export const B700 = '#023280';
export const B800 = '#03255B';

// Secondary Blue
export const SB50 = '#EEF9FF';
export const SB100 = '#D5EBFB';
export const SB200 = '#7FBDE5';
export const SB300 = '#3A97D4';
export const SB400 = '#2978AE';
export const SB500 = '#1F5C84';
export const SB600 = '#10486C';
export const SB700 = '#103E5B';
export const SB800 = '#0E3148';

// Green
export const G50 = '#E9FFF3';
export const G100 = '#B7FAD2';
export const G200 = '#81D9A5';
export const G300 = '#58CF88';
export const G400 = '#36B368';
export const G500 = '#2F9D5B';
export const G600 = '#267E49';
export const G700 = '#174F2D';
export const G800 = '#0E381F';

// Red
export const R50 = '#FFF3F3';
export const R100 = '#FFC5C5';
export const R200 = '#FF9B9B';
export const R300 = '#FC6363';
export const R400 = '#F93A3A';
export const R500 = '#E01919';
export const R600 = '#B20606';
export const R700 = '#820606';
export const R800 = '#5C0202';

// Yellow
export const Y50 = '#FEF9EC';
export const Y100 = '#FFE9B6';
export const Y200 = '#FFD165';
export const Y300 = '#FABC2A';
export const Y400 = '#F9B310';
export const Y500 = '#DB9B06';
export const Y600 = '#BA8303';
export const Y700 = '#946802';
export const Y800 = '#712600';

// Neutral Variant
export const N0 = '#FFFFFF';
export const N25 = '#FFFBFE';
export const N50 = '#F4EFF4';
export const N100 = '#E6E1E5';
export const N200 = '#C9C5CA';
export const N300 = '#AEAAAE';
export const N400 = '#939094';
export const N500 = '#787579';
export const N600 = '#605D62';
export const N700 = '#484649';
export const N800 = '#313033';
export const N900 = '#1C1B1F';
export const N1000 = '#000000';

// Base Color
//
export const BasePrimary = B400;
export const BaseAccent = SB400;
export const BaseNegative = R400;
export const BasePositive = G400;
export const BaseWarning = Y400;
